import { render, staticRenderFns } from "./ITStartup_2.vue?vue&type=template&id=d6e7293e&"
import script from "./ITStartup_2.vue?vue&type=script&lang=js&"
export * from "./ITStartup_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports